<form [formGroup]="form">
    <div class="card-box-medium margin-right-small">
        <h3 *ngIf="!loading"><span>{{invoicePointName}}
          <button  type="button" (click)="refreshInvoicePointName()"    mat-mini-fab class="card-inline">
          <mat-icon>autorenew</mat-icon>
        </button></span>
        </h3>
        <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
        <mat-divider></mat-divider>
        <div class="aling-top full-width margin-top-medium">

            <mat-form-field *ngIf="canEditInvoicePoint && !isPatient" class="full-width">
                <mat-select (selectionChange)="invoicePointSelectManualTypeChange()" formControlName="InvoicePointSelectManualType" placeholder="Tipo selección de punto de venta">
                    <mat-option *ngFor="let invoicePointSelectManualType of invoicePointSelectManualTypes" [value]="invoicePointSelectManualType">
                        {{invoicePointSelectManualType.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="card-inline  margin-right-small">
                <mat-label>Monto neto a abonar</mat-label>
                <input type="number" matInput formControlName="Amount">
                <mat-error *ngIf="!f.Amount.valid">
                    Ingrese el monto neto a abonar
                </mat-error>
            </mat-form-field>

            <mat-form-field class="margin-right-small">
                <input type="text" matInput placeholder="Tipo contribuyente impositivo" formControlName="TaxpayerType" [matAutocomplete]="autTaxpayerType">
                <mat-autocomplete #autTaxpayerType="matAutocomplete" (optionSelected)="taxpayerTypeSelected($event.option.value)" [displayWith]="filterCompleteTaxpayerTypes.displayFn">
                    <mat-option *ngFor="let taxpayerType of filteredTaxpayerTypesOptions | async" [value]="taxpayerType">
                        {{taxpayerType.Name}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="!f.TaxpayerType.valid">
                    Ingrese el tipo contribuyente impositivo
                </mat-error>
            </mat-form-field>

            <mat-form-field class="margin-right-small">
                <input type="text" matInput placeholder="Tipo factura" formControlName="InvoiceLabelType" [matAutocomplete]="autInvoiceLabelTypes">
                <mat-autocomplete (optionSelected)="invoiceLabelTypeSelected($event.option.value)" #autInvoiceLabelTypes="matAutocomplete" [displayWith]="filterCompleteInvoiceLabelTypes.displayFn">
                    <mat-option *ngFor="let invoiceLabelType of filteredInvoiceLabelTypesOptions | async" [value]="invoiceLabelType">
                        {{invoiceLabelType.Name}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="!f.InvoiceLabelType.valid">
                    Ingrese el tipo de factura
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="canEditInvoicePoint && (isPatient || isManualInvoicePointSelectType)">
                <input type="text" matInput placeholder="Punto venta" formControlName="InvoicePointManual" [matAutocomplete]="autInvoicePoint">
                <mat-autocomplete (optionSelected)="invoicePointChange($event.option.value)" #autInvoicePoint="matAutocomplete" [displayWith]="filterCompleteInvoicePoint.displayFn">
                    <mat-option *ngFor="let invoicePoint of filteredInvoicePointOptions | async" [value]="invoicePoint">
                        {{invoicePoint.Name}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="!f.InvoicePointManual.valid">
                    Ingrese el punto de venta
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="canEditInvoicePoint && isManualInvoicePointSelectType && !isPatient">
                <input type="text" matInput placeholder="Servicio" formControlName="ServiceManual" [matAutocomplete]="autServiceManual">
                <mat-autocomplete #autServiceManual="matAutocomplete" [displayWith]="filterCompleteServiceManual.displayFn">
                    <mat-option *ngFor="let service of filteredServiceManualOptions | async" [value]="service">
                        {{service.Name}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="!f.ServiceManual.valid">
                    Ingrese el servicio
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="canEditInvoicePoint && !isManualInvoicePointSelectType && !isPatient">

                <input type="text" matInput placeholder="Servicio" formControlName="Service" [matAutocomplete]="autServices">
                <mat-autocomplete (optionSelected)="serviceSelected($event.option.value)" #autServices="matAutocomplete" [displayWith]="filterCompleteService.displayFn">
                    <mat-option *ngFor="let service of filteredServiceOptions | async" [value]="service">
                        {{service.Name}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="!f.Service.valid">
                    Ingrese el servicio
                </mat-error>
            </mat-form-field>

            <table class="search-table" mat-table *ngIf="invoiceTaxes.controls.length > 0" [dataSource]="invoiceTaxesDataSource" formArrayName="InvoiceTaxes">
                <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayInvoiceTaxesColumns"></tr>
                <tr mat-row class="search-table-cell" *matRowDef="let row; let i = index; columns: displayInvoiceTaxesColumns;"></tr>

                <ng-container matColumnDef="TaxTypeName">
                    <th mat-header-cell class="table-header" *matHeaderCellDef> Impuesto </th>
                    <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayTaxTypeName(index)}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Aliquot">
                    <th mat-header-cell class="table-header" *matHeaderCellDef> Alícuota </th>
                    <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                        <mat-select (selectionChange)="aliquotChange()" formControlName="Aliquot">
                            <mat-option *ngFor="let aliquot of displayAmountAliquots(index)" [value]="aliquot">
                                {{aliquot}}
                            </mat-option>
                        </mat-select>
                    </td>
                </ng-container>
                <ng-container matColumnDef="Amount">
                    <th mat-header-cell class="table-header" *matHeaderCellDef>Importe </th>
                    <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayAmount(index) | number : '1.2-2'}}
                    </td>
                </ng-container>
            </table>

            <mat-form-field class="full-width margin-right-small">
                <mat-label>Descripción</mat-label>
                <input matInput autocomplete="off" formControlName="Description">
                <mat-error *ngIf="!f.Description.valid">
                    Debe ingresar una descripción
                </mat-error>
            </mat-form-field>

            <div *ngIf="getClientRequired()">
                <client-autocomplete class="full-width" formControlName="ClientSearch"></client-autocomplete>
                <mat-error *ngIf="errors?.validClient">
                    No ha ingresado algún cliente
                </mat-error>
            </div>

            <mat-form-field class="full-width margin-right-small" *ngIf="!canEditInvoicePoint">
                <mat-label>Razón social</mat-label>
                <input matInput formControlName="BusinessName">
                <mat-error *ngIf="!f.BusinessName.valid">
                    Debe ingresar una descripción
                </mat-error>
            </mat-form-field>

            <mat-form-field class="medium-width margin-right-small" *ngIf="canEditInvoicePoint">
                <mat-label>Razón social</mat-label>
                <input matInput formControlName="BusinessName">
                <mat-error *ngIf="!f.BusinessName.valid">
                    Debe ingresar una descripción
                </mat-error>
            </mat-form-field>

            <mat-form-field class="medium-width margin-right-small" *ngIf="canEditInvoicePoint">
                <mat-label>Documento</mat-label>
                <input type="number" matInput formControlName="Document">
                <mat-error *ngIf="!f.Document.valid">
                    Debe ingresar el documento
                </mat-error>
            </mat-form-field>




        </div>
    </div>

    <div class="card-box-medium margin-right-small">
        <h3>Médios de pago</h3>
        <mat-divider></mat-divider>
        <div class="aling-top medium-width margin-top-medium">

            <br>
            <div class="card-inline full-width margin-right-small" formGroupName="InvoiceCashDeskPaymentCash">
                <mat-form-field>
                    <mat-label>Efectivo</mat-label>
                    <input type="number" autocomplete="off" (focus)="cashDeskPaymentFocus(0)" matInput formControlName="PaymentAmount">
                </mat-form-field>
            </div>

            <div class="card-inline full-width  margin-right-small" formGroupName="InvoiceCashDeskPaymentDebitCard">
                <mat-form-field>
                    <mat-label>Tarj. débito</mat-label>
                    <input type="number" autocomplete="off" (focus)="cashDeskPaymentFocus(1)" matInput formControlName="PaymentAmount">
                </mat-form-field>
            </div>

            <div class="card-inline full-width margin-right-small" formGroupName="InvoiceCashDeskPaymentCreditCard">
                <mat-form-field>
                    <mat-label>Tarj. crédito</mat-label>
                    <input type="number" autocomplete="off" (focus)="cashDeskPaymentFocus(2)" matInput formControlName="PaymentAmount">
                </mat-form-field>
            </div>

            <div class="card-inline full-width  margin-right-small" formGroupName="InvoiceCashDeskPaymentCheck">
                <mat-form-field>
                    <mat-label>Cheque</mat-label>
                    <input type="number" autocomplete="off" (focus)="cashDeskPaymentFocus(3)" matInput formControlName="PaymentAmount">
                </mat-form-field>
            </div>

            <div class="card-inline full-width  margin-right-small" formGroupName="InvoiceCashDeskPaymentWireTransfer">
                <mat-form-field>
                    <mat-label>Transferencia / QR / Link</mat-label>
                    <input type="number" autocomplete="off" (focus)="cashDeskPaymentFocus(4)" matInput formControlName="PaymentAmount">
                </mat-form-field>
            </div>



        </div>
        <h3 *ngIf="isVisiblePaymentDetails">Detalle de los médios de pago</h3>
        <mat-divider *ngIf="isVisiblePaymentDetails"></mat-divider>
        <div class="aling-top full-width margin-top-medium">
            <div *ngIf="isVisiblePaymentDebitCard" class="card-inline  margin-right-small" formGroupName="InvoiceCashDeskPaymentDebitCard">
                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Billetera virtual" formControlName="VirtualWalletFilter" [matAutocomplete]="autDebitCardVirtualWallet">
                    <mat-autocomplete #autDebitCardVirtualWallet="matAutocomplete" [displayWith]="filterCompleteVirtualWalletPaymentDebitCard.displayFn">
                        <mat-option *ngFor="let virtualWallet of filteredVirtualWalletPaymentDebitCardOptions | async" [value]="virtualWallet">
                            {{virtualWallet.Name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Banco" formControlName="BankFilter" [matAutocomplete]="autDebitCardBank">
                    <mat-autocomplete #autDebitCardBank="matAutocomplete" [displayWith]="filterCompleteBanksPaymentDebitCard.displayFn">
                        <mat-option *ngFor="let bank of filteredBankPaymentDebitCardOptions | async" [value]="bank">
                            {{bank.Name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!invoiceCashDeskPaymentDebitCard.BankFilter.valid">
                        Debe ingresar el banco
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Tarjeta" formControlName="CreditCardFilter" [matAutocomplete]="autDebitCardCreditCardFilter">
                    <mat-autocomplete #autDebitCardCreditCardFilter="matAutocomplete" [displayWith]="filterCompleteCreditCardsPaymentDebitCard.displayFn">
                        <mat-option *ngFor="let creditCardFilter of filteredCreditCargPaymentDebitCardOptions | async" [value]="creditCardFilter">
                            {{creditCardFilter.Name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!invoiceCashDeskPaymentDebitCard.CreditCardFilter.valid">
                        Debe ingresar la trajeta
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width card-inline  margin-right-small">
                    <mat-label>Número tarjeta</mat-label>
                    <input matInput autocomplete="off" formControlName="CreditCardNumber">
                    <mat-error *ngIf="!invoiceCashDeskPaymentDebitCard.CreditCardNumber.valid">
                        Debe ingresar el número
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width card-inline  margin-right-small">
                    <mat-label>Cupón</mat-label>
                    <input matInput autocomplete="off" formControlName="Coupon">
                    <mat-error *ngIf="!invoiceCashDeskPaymentDebitCard.Coupon.valid">
                        Debe ingresar el cupón
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width card-inline  margin-right-small">
                    <mat-label>Cuotas</mat-label>
                    <input matInput autocomplete="off" formControlName="Dues">
                    <mat-error *ngIf="!invoiceCashDeskPaymentDebitCard.Dues.valid">
                        Debe ingresar las cuotas
                    </mat-error>
                </mat-form-field>
            </div>

            <div *ngIf="isVisiblePaymentCreditCard" class="full-width card-inline  margin-right-small" formGroupName="InvoiceCashDeskPaymentCreditCard">

                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Billetera virtual" formControlName="VirtualWalletFilter" [matAutocomplete]="autCreditVirtualWallet">
                    <mat-autocomplete #autCreditVirtualWallet="matAutocomplete" [displayWith]="filterCompleteVirtualWalletPaymentCreditCard.displayFn">
                        <mat-option *ngFor="let virtualWallet of filteredVirtualWalletPaymentCreditCardOptions | async" [value]="virtualWallet">
                            {{virtualWallet.Name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="full-width  margin-right-small">
                    <input type="text" matInput placeholder="Banco" formControlName="BankFilter" [matAutocomplete]="autCreditCardBank">
                    <mat-autocomplete #autCreditCardBank="matAutocomplete" [displayWith]="filterCompleteBanksPaymentCreditCard.displayFn">
                        <mat-option *ngFor="let bank of filteredBankPaymentCreditCardOptions | async" [value]="bank">
                            {{bank.Name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!invoiceCashDeskPaymentCreditCard.BankFilter.valid">
                        Debe ingresar el banco
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Tarjeta" formControlName="CreditCardFilter" [matAutocomplete]="autCreditCardCreditCardFilter">
                    <mat-autocomplete #autCreditCardCreditCardFilter="matAutocomplete" [displayWith]="filterCompleteCreditCardsPaymentCreditCard.displayFn">
                        <mat-option *ngFor="let creditCardFilter of filteredCreditCargPaymentCreditCardOptions | async" [value]="creditCardFilter">
                            {{creditCardFilter.Name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!invoiceCashDeskPaymentCreditCard.CreditCardFilter.valid">
                        Debe ingresar la tarjeta
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width card-inline  margin-right-small">
                    <mat-label>Número tarjeta</mat-label>
                    <input matInput autocomplete="off" formControlName="CreditCardNumber">
                    <mat-error *ngIf="!invoiceCashDeskPaymentCreditCard.CreditCardNumber.valid">
                        Debe ingresar el número
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width card-inline  margin-right-small">
                    <mat-label>Cupón</mat-label>
                    <input matInput autocomplete="off" formControlName="Coupon">
                    <mat-error *ngIf="!invoiceCashDeskPaymentCreditCard.Coupon.valid">
                        Debe ingresar el cupón
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width card-inline  margin-right-small">
                    <mat-label>Cuotas</mat-label>
                    <input matInput autocomplete="off" formControlName="Dues">
                    <mat-error *ngIf="!invoiceCashDeskPaymentCreditCard.Dues.valid">
                        Debe ingresar las cuotas
                    </mat-error>
                </mat-form-field>
            </div>

            <div *ngIf="isVisiblePaymentCheck" class="full-width card-inline  margin-right-small" formGroupName="InvoiceCashDeskPaymentCheck">
                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Billetera virtual" formControlName="VirtualWalletFilter" [matAutocomplete]="autCheckVirtualWallet">
                    <mat-autocomplete #autCheckVirtualWallet="matAutocomplete" [displayWith]="filterCompleteVirtualWalletPaymentCheck.displayFn">
                        <mat-option *ngFor="let virtualWallet of filteredVirtualWalletPaymentCheckOptions | async" [value]="virtualWallet">
                            {{virtualWallet.Name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Banco" formControlName="BankFilter" [matAutocomplete]="autCheckBank">
                    <mat-autocomplete #autCheckBank="matAutocomplete" [displayWith]="filterCompleteBanksPaymentCheck.displayFn">
                        <mat-option *ngFor="let bank of filteredBankPaymentCheckOptions | async" [value]="bank">
                            {{bank.Name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!invoiceCashDeskPaymentCheck.BankFilter.valid">
                        Debe ingresar el banco
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width card-inline  margin-right-small">
                    <mat-label>Número cheque</mat-label>
                    <input matInput autocomplete="off" formControlName="CheckNumber">
                    <mat-error *ngIf="!invoiceCashDeskPaymentCheck.CheckNumber.valid">
                        Debe ingresar el número
                    </mat-error>
                </mat-form-field>
            </div>

            <div *ngIf="isVisiblePaymentWireTransfer" class="medium-width card-inline  margin-right-small" formGroupName="InvoiceCashDeskPaymentWireTransfer">


                <mat-form-field class="full-width margin-right-small">
                    <input type="text" matInput placeholder="Billetera virtual" formControlName="VirtualWalletFilter" [matAutocomplete]="autTransferVirtualWallet">
                    <mat-autocomplete #autTransferVirtualWallet="matAutocomplete" [displayWith]="filterCompleteVirtualWalletPaymentTransfer.displayFn">
                        <mat-option *ngFor="let virtualWallet of filteredVirtualWalletPaymentTransferOptions | async" [value]="virtualWallet">
                            {{virtualWallet.Name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="card-inline  margin-right-small">
                    <mat-label>Código transferencia</mat-label>
                    <input autocomplete="off" matInput formControlName="TranseferNumber">
                    <mat-error *ngIf="!invoiceCashDeskPaymentWireTransfer.TranseferNumber.valid">
                        Debe ingresar el número
                    </mat-error>
                </mat-form-field>
            </div>

        </div>

        <h3>Monto total</h3>
        <mat-divider></mat-divider>
        <b>{{totalText() | number : '1.2-2'}} </b>

        <div>
            <br />

            <mat-error *ngIf="errors?.validNumber">
                Falta el número de factura
            </mat-error>

            <mat-error *ngIf="errors?.validTotalPayment">
                El importe total no coincide con el total de pagos
            </mat-error>
        </div>
    </div>
</form>